module.exports = __webpack_public_path__ + "static/cirurgia_2-5fd3852b63cfd1123635b0fd7c18686d.jpg";